export const environment = {
  production: false,
  //baseurl:'http://localhost:30000/',
  baseurl: 'https://crm-consultorio-api.onrender.com/',
  baseurlReporteria: 'http://localhost:3013/',
  apiKeyReporteria: '39b06bef207e63f9fb1a6264854a60c74a1f1a0f'
};